<div class="bg-gray-50 border-t border-gray-200 px-3 py-2 flex items-center">
  <div class="mr-auto">
    <select [ngModel]="pageSize()"
            (ngModelChange)="onPageSizeChange($event)"
            data-testid="pager-page-size"
            class="p-1 border border-gray-300 rounded text-xs bg-white">

      @for (length of pageLengths(); track length) {
      <option [value]="length">{{ length }}</option>
      }
    </select>
  </div>

  <div class="text-xs text-gray-700 mx-4" data-testid="pager-info">
    {{ totalItems() }} items sur {{ total() }}
  </div>

  <div class="flex items-center space-x-1 ml-auto">
    <button (click)="onPageChange(page() - 1)" data-testid="pager-prev"
            [disabled]="page() === 1"
            [class.opacity-50]="page() === 1"
            class="px-2 py-1 text-gray-800 rounded text-xs">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
      </svg>
    </button>
    <span class="text-xs text-gray-700 mx-1">Page {{ page() }} / {{ totalPages() }}</span>
    <button (click)="onPageChange(page() + 1)" data-testid="pager-next"
            [disabled]="page() === totalPages()"
            [class.opacity-50]="page() === totalPages()"
            class="px-2 py-1 text-gray-800 rounded text-xs">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
      </svg>
    </button>
  </div>
</div>
